import { GlobalSearchEntityType } from 'generated/graphql';
import type { GlobalSearchForSearchOverlayQuery } from 'generated/graphql';
import { z } from 'zod/v4';

export type SearchResultHit =
  GlobalSearchForSearchOverlayQuery['globalSearch']['results'][number];
export type UserSearchHit = Extract<
  SearchResultHit,
  { __typename?: 'UserSearchHit' }
>;
export type DeskSearchHit = Extract<
  SearchResultHit,
  { __typename?: 'DeskSearchHit' }
>;
export type SpaceSearchHit = Extract<
  SearchResultHit,
  { __typename?: 'SpaceSearchHit' }
>;

const searchFields = {
  id: z.string(),
  entityId: z.string(),
  displayName: z.string(),
  entityType: z.enum(GlobalSearchEntityType),
};

const DeskSearchHitSchema = z.object({
  __typename: z.literal('DeskSearchHit'),
  ...searchFields,
  locationId: z.string(),
  locationName: z.string().nullable().optional(),
  levelId: z.string().nullable().optional(),
  levelName: z.string().nullable().optional(),
});

const SpaceSearchHitSchema = z.object({
  __typename: z.literal('SpaceSearchHit'),
  ...searchFields,
  locationId: z.string(),
  locationName: z.string().nullable().optional(),
  levelId: z.string().nullable().optional(),
  levelName: z.string().nullable().optional(),
});

const UserSearchHitSchema = z.object({
  __typename: z.literal('UserSearchHit'),
  ...searchFields,
  email: z.string().nullable().optional(),
  avatarUrl: z.string().nullable().optional(),
});

const SearchResultHitSchema = z.discriminatedUnion('__typename', [
  DeskSearchHitSchema,
  SpaceSearchHitSchema,
  UserSearchHitSchema,
]);

export const SearchOverlaySnapshotSchema = z.object({
  sessionToken: z.string(),
  orgId: z.string(),
  query: z.string(),
  selectedLocationId: z.string().nullable(),
  selectedCategory: z.nativeEnum(GlobalSearchEntityType).nullable(),
  results: z
    .array(SearchResultHitSchema)
    .transform((hits) => hits as SearchResultHit[]),
  savedAt: z.number(),
});

export type SearchOverlaySnapshot = z.infer<typeof SearchOverlaySnapshotSchema>;
